module.exports = __webpack_public_path__ + "static/media/vulcan.270b9378.png";